module.exports = "/_next/static/images/bucharest-a6ab26d2ec3d2b9fea0d021def879cfc.png.webp";